import { render, staticRenderFns } from "./gestion.vue?vue&type=template&id=27258c7d&scoped=true&"
import script from "./gestion.vue?vue&type=script&lang=js&"
export * from "./gestion.vue?vue&type=script&lang=js&"
import style0 from "./gestion.vue?vue&type=style&index=0&id=27258c7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27258c7d",
  null
  
)

export default component.exports